import { useTranslation } from 'react-i18next'
import { SelectFilter } from '../../../../rapid-ui'

interface OrganizationPaginationProps {
	currentPage: number
	totalPages: number
	totalUsers: number
	actualItemsOnPage: number
	itemsPerPage: number
	isPlaceholderData: boolean
	onPreviousPage: () => void
	onNextPage: () => void
	onItemsPerPageChange: (value: string) => void
}

export function OrganizationPagination({
	currentPage,
	totalPages,
	totalUsers,
	actualItemsOnPage,
	itemsPerPage,
	isPlaceholderData,
	onPreviousPage,
	onNextPage,
	onItemsPerPageChange,
}: OrganizationPaginationProps) {
	const { t } = useTranslation('common')

	if (totalUsers === 0) {
		return null
	}

	return (
		<div className="flex items-center justify-between gap-4 mt-4">
			<div className="flex items-center gap-2">
				<span className="text-sm text-gray-600">
					{t('organization.pagination.showing', { count: actualItemsOnPage, total: totalUsers })}
				</span>
			</div>

			<div className="flex items-center gap-4">
				<div className="flex items-center gap-2">
					<span className="text-sm text-gray-600">{t('organization.pagination.itemsPerPage')}</span>
					<SelectFilter
						options={[
							{ id: '10', label: '10' },
							{ id: '25', label: '25' },
							{ id: '50', label: '50' },
						]}
						value={String(itemsPerPage)}
						onChange={onItemsPerPageChange}
					/>
				</div>

				<div className="flex items-center gap-2">
					<button
						onClick={onPreviousPage}
						disabled={currentPage === 1 || isPlaceholderData}
						className="px-3 py-1 border rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
						aria-label={t('organization.pagination.previousPage')}
					>
						←
					</button>
					<span className="text-sm text-gray-600">
						{t('organization.pagination.page', { current: currentPage, total: totalPages })}
					</span>
					<button
						onClick={onNextPage}
						disabled={currentPage >= totalPages || isPlaceholderData}
						className="px-3 py-1 border rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
						aria-label={t('organization.pagination.nextPage')}
					>
						→
					</button>
				</div>
			</div>
		</div>
	)
}
